import { Component, HostListener } from '@angular/core';
import { UrlService } from '../../services/url.service';
import { ApiClientService } from '../../services/api-client.service';
import { AuthenticationService } from '../../services/authentication.service';
import {PropertyService} from '../../views/admin/property/services/property.service';

declare const toastr: any;

@Component({
    selector: 'properties-filter',
    templateUrl: './properties-filter.component.html',
    styleUrls: ['./properties-filter.component.scss']
})
export class PropertiesFilterComponent {
    showDropdown = false;
    timeoutForFilterChanging = null;

    constructor(private urlService: UrlService,
                public propertyService: PropertyService,
                public api: ApiClientService,
                public authenticationService: AuthenticationService,
    ) { }

    changeFilter() {
        this.urlService.queryParams['company_id'] = [];
        const checkboxes = (<any>document.getElementsByClassName('amenities-filter-items-wrapper')[0]).childNodes;
        for(let i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].classList && checkboxes[i].classList.value.indexOf('filter-checkbox') != -1) {
                if(checkboxes[i].childNodes[1].childNodes[1].checked)
                    this.urlService.queryParams['company_id'].push(checkboxes[i].childNodes[1].childNodes[1].id);
            }
        }

        this.urlService.setQueryParams(null, 1);
    }

    timeOutBeforeFilterChanging(): void {
        if(this.timeoutForFilterChanging)
            clearTimeout(this.timeoutForFilterChanging);
        this.timeoutForFilterChanging = setTimeout(() => this.changeFilter(), 1000);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('properties-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/properties-filter/properties-filter.component.ts